import { httpService } from '@/services/HttpService';

class PricesService {
  getPrices(workspaceId: number, regionId: number) {
    return httpService.get(`workspaces/${workspaceId}/billing/prices?region_id=${regionId}`);
  }
}

export const pricesService = new PricesService();
